import { render } from "./BurnedWidget.vue?vue&type=template&id=0dc005a0&scoped=true"
import script from "./BurnedWidget.vue?vue&type=script&lang=js"
export * from "./BurnedWidget.vue?vue&type=script&lang=js"

import "./BurnedWidget.vue?vue&type=style&index=0&id=0dc005a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc005a0"]])

export default __exports__